import { FBPageTableContainer } from 'components/FbUI/Page/styles'
import { MiscSettingsTable } from 'features/settings/components/MiscSettingsTable'

export function MiscSettingsPage() {
  return (
    <div className="w-full h-full flex flex-col flex-1 min-h-0">
      <FBPageTableContainer>
        <MiscSettingsTable />
      </FBPageTableContainer>
    </div>
  )
}
